<template>
    <div
        class="
        container
        has-text-centered
        is-rounded
        rounded"
        :class="[
            backgroundcolourClass,
            paddingClass,
            marginClass
        ]"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'RoundedContainer',
        props: {
            backgroundcolourClass: {
                type: String,
                default: 'has-background-light'
            },
            paddingClass: {type: String, default: 'p-4'},
            marginClass: {type: String, default: 'm-5'},
        }
    }
</script>

